import React, { useState } from 'react';
import { LeftArrow, MailIcon } from '../../icons';
import Container from '../../components/elements/container';

const Notifications = ({ isLoading, notificationData }) => {
  const [messageDetails, setSelectedMessage] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const windowWidth = window.screen.width;

  if (isLoading) {
    return <Container>Loading..</Container>;
  }

  if (showDetails && windowWidth <= 991) {
    return (
      <div className="lg:hidden container-sm bg-white lg:max-h-[95vh] h-full overflow-y-auto flex flex-col px-5 gap-5">
        <div className="flex gap-3 border-b border-b-fadedgrey py-2">
          <button
            type="button"
            className=""
            onClick={() => setShowDetails(false)}
          >
            <LeftArrow />
          </button>
          <h2>Messages</h2>
        </div>
        <div className="flex border border-fadedgrey p-5 rounded-md">
          <div className="flex flex-col gap-2">
            <h6>{messageDetails.title}</h6>
            <p className="text-body text-granite ">{messageDetails.message}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-sm bg-white h-[calc(100vh-75px)] overflow-y-auto scrollbar ">
      <div className="grid lg:grid-cols-3 gap-6 lg:p-6 p-5">
        <ul className="flex flex-col gap-3 overflow-y-auto scrollbar">
          {notificationData.messages.map((messageData) => {
            const { title, message } = messageData;

            if (messageDetails && title === messageDetails.title) {
              return (
                <li
                  key={title}
                  className="max-lg:hidden flex bg-black border border-fadedgrey rounded-lg p-3 gap-3"
                  role="button"
                  onClick={() => setSelectedMessage(messageData)}
                >
                  <MailIcon className="stroke-white" />
                  <div className="flex gap-2 w-full">
                    <div className="flex flex-col gap-2 flex-1">
                      <h6 className="text-white">{title}</h6>

                      <p title={message} className="text-body text-white overflow-hidden truncate lg:w-96">
                        {message}
                      </p>
                    </div>
                  </div>
                </li>
              );
            }

            return (
              <li
                key={title}
                className="flex bg-white border border-fadedgrey rounded-lg p-3 gap-3 overflow-hidden"
                role="button"
                onClick={() => {
                  setShowDetails(true);
                  setSelectedMessage(messageData);
                }}
              >
                <MailIcon className="stroke-black" />
                <div className="flex gap-2 lg:w-full">
                  <div className="flex flex-col gap-2 flex-1">
                    <h6>{title}</h6>

                    <p title={message} className="text-body text-granite overflow-hidden truncate lg:w-96 w-60 max-lg:max-w-[220px]">
                      {message}
                    </p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        {messageDetails ? (
          <div className="max-lg:hidden col-span-2 flex p-6 border border-fadedgrey rounded-lg bg-white h-fit">
            <div className="flex">
              <div className="flex flex-col gap-2">
                <h6>{messageDetails.title}</h6>
                <p className="text-body text-granite ">
                  {messageDetails.message}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="max-lg:hidden col-span-2 flex p-6 border border-fadedgrey rounded-lg bg-white h-[300px] items-center justify-center">
            <div className="text-body text-granite">
            Επίλεξε μια ειδοποίηση για να διαβάσεις όλο το περιεχόμενο.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;
